import './TagSlider.css';

const TagSlider = ({
  postsHashTags = [],
  setHashtag,
  cat_id,
  cat_name,
  cat_icon,
  setCatalogy,
}) => {
  const extendedTags =
    cat_id && cat_name
      ? [{ id: cat_id, name: cat_name, image: cat_icon }, ...postsHashTags]
      : postsHashTags;

  return (
    <div className="tag-slider-wrapper">
      <div className="tag-slider-track">
        {extendedTags.map((tag, index) => (
          <button
            key={index}
            className="tag-item"
            onClick={() => {
              if (cat_id && index === 0) {
                setCatalogy(tag.id); // Chỉ phần tử đầu tiên khi có cat_id
              } else {
                setHashtag(tag.name); // Các phần tử còn lại là hashtag
              }
            }}
          >
            {tag.image && (
              <img src={tag.image} alt={tag.name} className="tag-icon" />
            )}
            <span>{tag.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TagSlider;
